export const languages = [
  { code: "en", title: "English" },
  { code: "es", title: "Spanish" },
];
